module.exports = __webpack_public_path__ + "static/media/horse-head.a77f82e3.svg";